/* tslint:disable */
/* eslint-disable */
/**
 * Care-Calendar Widget Selection API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { SelectableWidgetResultsRestDto } from '../models';
/**
 * WidgetSelectionApi - axios parameter creator
 * @export
 */
export const WidgetSelectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all active (published) embedded booking widgets of the authenticated customer, as code/description pairs for a selection dropdown. A widget is active when its status is PUBLISHED; widgets that are NOT_PUBLISHED or deleted are never returned. The 'code' is the widget code that has to be stored in the consuming configuration (eg. the CMS calendar content block) and that is used by Pharma SMA to render the widget. Results are sorted alphabetically by description. An empty results array is returned when the customer has no active widgets.
         * @summary REST.API.CAL.WSEL.01 Get the list of active widgets for the authenticated customer.
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content and possible application errors are expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSelectableBookingWidgets: async (x_dp_customer_code: string, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling findSelectableBookingWidgets.');
            }
            const localVarPath = `/widget/v1/selectable_booking_widget`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetSelectionApi - functional programming interface
 * @export
 */
export const WidgetSelectionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns all active (published) embedded booking widgets of the authenticated customer, as code/description pairs for a selection dropdown. A widget is active when its status is PUBLISHED; widgets that are NOT_PUBLISHED or deleted are never returned. The 'code' is the widget code that has to be stored in the consuming configuration (eg. the CMS calendar content block) and that is used by Pharma SMA to render the widget. Results are sorted alphabetically by description. An empty results array is returned when the customer has no active widgets.
         * @summary REST.API.CAL.WSEL.01 Get the list of active widgets for the authenticated customer.
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content and possible application errors are expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSelectableBookingWidgets(_axios: AxiosInstance, x_dp_customer_code: string, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectableWidgetResultsRestDto>> {
            const localVarAxiosArgs = await WidgetSelectionApiAxiosParamCreator(configuration).findSelectableBookingWidgets(x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WidgetSelectionApi - object-oriented interface
 * @export
 * @class WidgetSelectionApi
 * @extends {BaseAPI}
 */
export class WidgetSelectionApi extends BaseAPI {
    /**
     * Returns all active (published) embedded booking widgets of the authenticated customer, as code/description pairs for a selection dropdown. A widget is active when its status is PUBLISHED; widgets that are NOT_PUBLISHED or deleted are never returned. The 'code' is the widget code that has to be stored in the consuming configuration (eg. the CMS calendar content block) and that is used by Pharma SMA to render the widget. Results are sorted alphabetically by description. An empty results array is returned when the customer has no active widgets.
     * @summary REST.API.CAL.WSEL.01 Get the list of active widgets for the authenticated customer.
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which language the content and possible application errors are expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetSelectionApi
     */
     public findSelectableBookingWidgets(x_dp_customer_code: string, x_dp_language?: string|null, options?: any) {
        return WidgetSelectionApiFp(this.configuration).findSelectableBookingWidgets(this.axios, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
